var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"file-download d-flex justify-space-between"},[_c('div',{staticClass:"d-flex"},[_c('v-icon',[_vm._v("mdi-file")]),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.file.name))])],1),_c('div',{staticClass:"download",on:{"click":_vm.download}},[_vm._v(" "+_vm._s(_vm.$t('download'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }